import { useEffect, useRef, useState } from 'react'
import './index.css'

//assets
import top_bg from './assets/top_bg1.svg'
import middle_bg from './assets/middle_bg.svg'
import bottom_bg from './assets/bottom_bg.svg'
import robot from './assets/robot.png'
import robot_gif from './assets/robot_gif.gif'
import robot_gif_multiview from './assets/robot_gif_multiview.gif'
import shark from './assets/shark.png'
import turtle from './assets/turtle.png'
import turtle_shark from './assets/turtle_shark.png'
import arrow from './assets/arrow.png'
import fusion_icon from './assets/fusion_icon.png'
import mark from './assets/mark.svg'
import multiview1 from './assets/multiview-1.png'
import multiview2 from './assets/multiview-2.png'
import multiview3 from './assets/multiview-3.png'
import multiview4 from './assets/multiview-4.png'
import multiviewadd from './assets/multiview-add.png'

export const RodinDriverAnimation = ({ open }) => {
  const generationMethods = ['Multi-view', 'Fusion']
  const intervalRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [currentGenerationMethod, setCurrentGenerationMethod] = useState(0)
  const [showFull, setShowFull] = useState(false)
  const [fusionAnimationDone, setFusionAnimationDone] = useState(0)
  const [multiviewAnimationDone, setMultiviewAnimationDone] = useState(0)


  useEffect(() => {
    if (!showFull) {
      if (open) {
        setTimeout(() => {
          setShowFull(true)
        }, 800);
      }
    } else {
      open ? handleResume() : handlePause()
    }
  }, [open])

  useEffect(() => {
    if (!isPaused && showFull) {
      intervalRef.current = setInterval(() => {
        animation((prevIndex) => (prevIndex + 1) % 2)
      }, 3000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPaused, showFull]);

  useEffect(() => {
    if (currentGenerationMethod === 1) {
      setFusionAnimationDone(pre => pre + 1)
    }
    if (currentGenerationMethod === 0) {
      setMultiviewAnimationDone(pre => pre + 1)
    }
  }, [currentGenerationMethod])

  const handlePause = () => {
    setIsPaused(true);
  };

  const handleResume = () => {
    setIsPaused(false);
  };

  const animation = (cb) => {
    setTimeout(() => {
      setCurrentGenerationMethod(cb);
    }, 300);
  }

  const handleMouseEnterGenerationMethods = (index) => {
    if (index !== generationMethods) {
      handlePause()
      setCurrentGenerationMethod(index)
    }
  }

  const handleMouseLeaveGenerationMethods = () => {
    handleResume()
  }

  const fusionFirstAnimation = (currentGenerationMethod === 1 && fusionAnimationDone === 1)
  const multiviewFirstAnimation = (currentGenerationMethod === 0 && multiviewAnimationDone === 1)

  return (
    <div className={`absolute top-1/2 right-[-20px] w-[332px] p-[6px]  rounded-[19px] bg-[rgba(0,0,0,0.42)] backdrop-blur-lg select-none [transition:0.3s_ease] [transform-origin:center_left]
    ${open ? '[transform:translate(100%,-50%)_scale(1)]  opacity-100' : '[transform:translate(100%,-50%)_scale(0)] opacity-0'}
    ${showFull ? 'h-[256px]' : 'h-[126px]'}`}>
      <div className='overflow-hidden h-full'>
        <div className={`w-full h-full flex flex-col justify-evenly `}>
          <div
            style={{
              backgroundImage: `url(${top_bg})`,
              backgroundRepeat: 'no-repeat',
            }}>
            <div className='flex h-[23px]'>
              <p className='w-[130px] h-full text-white text-xs leading-[26px]'>Single image</p>
              <div className='w-[142px]'></div>
            </div>
            <div className='flex w-full h-[95px]'>
              <div className='w-[130px] h-full flex'>
                <img src={robot} className='h-[80%] m-auto' alt="robot" />
              </div>
              <div className='w-[182px] h-full flex justify-evenly items-center'>
                <img src={arrow} className='h-[30px]' alt="arrow" />
                <img src={robot_gif} className={`h-[90%] transition-300-ease ${!showFull ? '[transform:scale(1.4)_translateY(-10px)]' : '[transform:scale(1)_translateY(0px)]'}`} alt="robot_gif" />
              </div>
            </div>
          </div>
          {<div className={`transition-300-ease flex flex-col justify-between gap-[6px] [transform-origin:50px_top] overflow-hidden ${showFull ? '[transform:sacle(1)]' : '[transform:scale(0)]'}`}>
            <div
              className='h-[18px] flex items-center justify-between transition-300-ease'
              style={{
                backgroundImage: `url(${middle_bg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '137px 18px',
                backgroundPosition: `${currentGenerationMethod === 0 ? '10px' : '170px'}`,
              }}>
              {generationMethods.map((item, index) => (
                <span
                  key={item}
                  onMouseEnter={handleMouseEnterGenerationMethods.bind(null, index)}
                  onMouseMove={handleMouseEnterGenerationMethods.bind(null, index)}
                  onMouseLeave={handleMouseLeaveGenerationMethods}
                  className={`text-xs  flex-1 transition-300-ease
            ${currentGenerationMethod === index ? 'text-[rgba(255,255,255,1)]' : 'text-[rgba(255,255,255,0.2)]'}`}>
                  {item}
                </span>
              ))}
            </div>
            <div
              className='h-[96px] relative p-2'
              style={{
                backgroundImage: `url(${bottom_bg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '320px 96px',
              }}>
              <div className={`absolute w-full h-full top-0 left-0 flex justify-between transition-300-ease [transform-origin:bottom_left]
           ${currentGenerationMethod === 0 ? '[transform:translate3d(0,0,0)] opacity-100' : '[transform:translate3d(-20%,0,0)]  opacity-0'} `}>
                <div className='flex flex-col justify-around items-center p-[8px] h-full w-[233px]'>
                  <div className=' relative w-full  h-full'>
                    <div className={`overflow-hidden h-full w-full flex items-center gap-[4px]`}>
                      <div className={`${showFull && multiviewFirstAnimation ? 'animation-multiview-slideIn1' : ''}`} >
                        <img className='w-[46px] h-[63px]' src={multiview1} alt="multiview1" />
                      </div>
                      <div className={`${showFull && multiviewFirstAnimation ? 'animation-multiview-slideIn2' : ''}`} >
                        <img className='w-[12px]' src={multiviewadd} alt="multiviewadd" />
                      </div>
                      <div className={`overflow-hidden rounded-[3px] bg-[rgba(186,176,169,1)] 
                        ${showFull ? multiviewFirstAnimation ? 'animation-multiview-slideIn2-combine' : 'animation-multiview-shadow' : ''}`} >
                        <img className={`w-[46px] h-[63px] ${showFull ? 'animation-multiview-scale1' : ''}`} src={multiview2} alt="multiview2" />
                      </div>
                      <div className={`${showFull && multiviewFirstAnimation ? 'animation-multiview-slideIn3' : ''}`} >
                        <img className='w-[12px]' src={multiviewadd} alt="multiviewadd" />
                      </div>
                      <div className={`overflow-hidden rounded-[3px] bg-[rgba(186,176,169,1)] 
                       ${showFull ? multiviewFirstAnimation ? 'animation-multiview-slideIn3-combine' : 'animation-multiview-shadow' : ''}`} >
                        <img className={`w-[46px] h-[63px] ${showFull ? 'animation-multiview-scale2' : ''}`} src={multiview3} alt="multiview3" />
                      </div>
                      <div className={`${showFull && multiviewFirstAnimation ? 'animation-multiview-slideIn4' : ''}`} >
                        <img className='w-[12px]' src={multiviewadd} alt="multiviewadd" />
                      </div>
                      <div className={`${showFull && multiviewFirstAnimation ? 'animation-multiview-slideIn4' : ''}`} >
                        <img className='w-[36px]' src={multiview4} alt="multiview4" />
                      </div>
                      {/* <img src={multiview} className='h-[45px] w-[154px]' alt="multiview" /> */}
                    </div>
                  </div>
                </div>
                <div className={`h-full flex justify-evenly items-center w-[87px]
                ${showFull && multiviewFirstAnimation ? 'opacity-0 animation-multiview-translateIn' : ''}`}>
                  <img src={arrow} className='h-[30px]' alt="arrow" />
                  <img src={robot_gif_multiview} className='h-[90%]' alt="robot_gif_multiview" />
                </div>
              </div>
              <div className={`absolute w-full h-full top-0 left-0 flex transition-300-ease 
            ${currentGenerationMethod === 1 ? '[transform:translate3d(0,0,0)] opacity-100' : '[transform:translate3d(20%,0,0)] opacity-0'}`}>
                <div className='flex justify-between items-center p-[8px] w-[184px] h-full'>
                  <img
                    src={turtle}
                    className={`w-[56px] relative z-[1]
                     ${fusionFirstAnimation ? '[transform:scale(0)] animation-fusion-scaleIn scaleIn-delay-1' : '[transform:scale(1)]'}
                    `}
                    alt="turtle" />
                  <img
                    src={fusion_icon}
                    className={` absolute left-[56px] top-1/2 m-auto w-[74px] z-0
                   ${fusionFirstAnimation ? '[transform:translate(0,-50%)_scale(0)] animation-fusion-scaleIn-2 scaleIn-delay-3' : '[transform:translate(0,-50%)_scale(1)]'}`}
                    alt="fusion_icon" />
                  <img
                    src={shark}
                    className={`w-[56px] relative z-[1]
                    ${fusionFirstAnimation ? '[transform:scale(0)] animation-fusion-scaleIn scaleIn-delay-2' : '[transform:scale(1)]'}`}
                    alt="shark" />
                </div>
                <div className={`h-full w-[136px] flex justify-evenly items-center 
                  ${fusionFirstAnimation ? '[transform:scale(0)] animation-fusion-translateIn  scaleIn-delay-4' : '[transform:scale(1)]'}`}>
                  <img src={arrow} className='h-[30px]' alt="arrow" />
                  <img
                    src={turtle_shark}
                    className={`w-[56px]`}
                    alt="turtle_shark" />
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
      <span className={`absolute bottom-0 transition-300-ease gap-1 flex items-center text-xs bg-[rgba(0,0,0,0.2)] [border:1px_solid_rgba(255,255,255,0.25)] [filter:drop-shadow(0_2px_28px_rgba(0,0,0,0.13))] shadow-[0_2px_28px_rgba(0,0,0,0.13)] text-[#b2b2b2] w-max rounded-2xl p-[2px_8px]
      ${showFull ? '[transform:translate(0,calc(100%+6px))_scale(1)]' : '[transform:translate(0,calc(-100%+6px))_scale(0)]'}`}>
        <img src={mark} className='h-[10px]' alt="mark" />
        Upload photos from any angle
      </span>
      <span className='absolute w-0 h-0 [border-color:transparent_rgba(0,0,0,0.42)_transparent_transparent] [border-style:solid] [border-width:15px_11px_15px_0] left-0 top-[50%] translate-x-[-100%] -translate-y-1/2 rounded-sm'></span>
    </div>
  );
};

export const RodinTextDriverAnimation = ({ textOpen }) => {
  const [dotAnimationStart, setDotAnimationStart] = useState(0)
  const [showFull, setShowFull] = useState(false)

  useEffect(() => {
    if (textOpen) {
      if (!showFull) {
        setTimeout(() => {
          setShowFull(true)
        }, 1200);
      }
      setDotAnimationStart(pre => pre + 1)
    }
  }, [textOpen])

  return (
    <div className={`absolute bottom-0 right-[-30px] w-[214px] p-[8px]  rounded-[19px] bg-[rgba(0,0,0,0.42)] select-none [transition:0.3s_ease] [transform-origin:center_left] overflow-hidden
    ${textOpen ? '[transform:translateX(100%)_scale(1)]  opacity-100' : '[transform:translateX(100%)_scale(0)] opacity-0'}
    ${showFull ? 'h-[131px]' : 'h-[36px]'}
    `}>
      <div className={`flex w-full overflow-hidden transition-300-ease]
        ${dotAnimationStart === 1 ? 'h-[0px] animation-textTop-fadeIn' : textOpen ? 'h-[95px]' : 'h-[0px]'}`}>
        <div className={`w-[100px] h-full flex
           ${dotAnimationStart === 1 ? 'animation-text-robot scale-0' : ''}`}>
          <img src={robot} className='h-[80%] m-auto' alt="robot" />
        </div>
        <div className={`w-[102px] h-full flex justify-evenly items-center
          ${dotAnimationStart === 1 ? 'animation-text-robot-gif opacity-0' : ''}`}>
          <img src={arrow} className='h-[30px]' alt="arrow" />
          <img src={robot_gif} className='h-[90%]' alt="robot_gif" />
        </div>
      </div>
      <div className='w-full h-[36px]'></div>
      <div className='absolute left-[8px] bottom-[8px] w-[198px] bg-[rgba(255,255,255,0.07)] [border:1px_solid_rgba(255,255,255,0.11)] rounded-xl text-xs text-white text-left pl-[10px] flex items-center gap-[1px]'>
        <span id="rodin-driver-animation-text" className={`${dotAnimationStart === 1 ? 'text-animation' : ''}`}>A Robot</span>
        {/* <img src={point} className={`${dotAnimationStart === 1 ? 'dot' : ''}`} alt="point" />
        <img src={point} className={`${dotAnimationStart === 1 ? 'dot' : ''}`} alt="point" />
        <img src={point} className={`${dotAnimationStart === 1 ? 'dot' : ''}`} alt="point" /> */}
        <div className={`${dotAnimationStart === 1 ? 'dot-a' : 'hidden'} ${showFull ? '!hidden' : ''}`}>...</div>
      </div>
    </div>
  )
}